import React from "react";
import type { ChordVoicingResult } from "../../lib/chordEngine";
import { parseCagedLetter } from "../../lib/chordCagedConstellation";
import { CagedConstellationIcon } from "./CagedConstellationIcon";

function shapeLabel(shapeName?: string, index: number): string {
  const letter = parseCagedLetter(shapeName);
  if (letter) return letter;
  if (shapeName) {
    const short = shapeName.replace(/^Shape\s+/i, "").split("(")[0].trim();
    if (short.length <= 12) return short;
  }
  return `Pos ${index + 1}`;
}

export interface ChordVoicingDotSelectorProps {
  voicings: ChordVoicingResult[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  /** Fila única junto a otros selectores (barra de teoría). */
  inline?: boolean;
}

export const ChordVoicingDotSelector: React.FC<ChordVoicingDotSelectorProps> = ({
  voicings,
  selectedIndex,
  onSelect,
  inline = false,
}) => {
  if (voicings.length === 0) return null;

  return (
    <div
      className={
        inline
          ? "flex flex-row items-end gap-3 shrink-0"
          : "flex flex-wrap items-end gap-x-6 gap-y-2"
      }
    >
      <div className={`flex flex-col gap-1.5 shrink-0 ${inline ? "" : "w-full mb-0.5"}`}>
        <span className="text-[10px] font-sans uppercase tracking-widest text-white/30">
          Forma
        </span>
        <div className="flex flex-row items-end gap-3">
      {voicings.map((v, idx) => {
        const active = idx === selectedIndex;
        const label = shapeLabel(v.shapeName, idx);
        return (
          <button
            key={`${v.shapeName ?? "v"}-${idx}`}
            type="button"
            onClick={() => onSelect(idx)}
            className="group flex cursor-pointer flex-col items-center gap-1.5"
          >
            <span
              className={`text-[10px] font-sans uppercase tracking-widest transition-colors ${
                active ? "text-white/80" : "text-white/30 group-hover:text-white/70"
              }`}
            >
              {label}
            </span>
            <CagedConstellationIcon shapeName={v.shapeName} active={active} />
          </button>
        );
      })}
        </div>
      </div>
    </div>
  );
};
